import c from '../assets/skills/c.svg';
import cplus from '../assets/skills/cplusplus.svg';
import css from '../assets/skills/css3.svg';
import django from '../assets/skills/django.svg';
import git from '../assets/skills/git.svg';
import html from '../assets/skills/html-5.svg';
import javascript from '../assets/skills/javascript.svg';
import mongodb from '../assets/skills/mongodb.svg';
import mysql from '../assets/skills/mysql.svg';
import nodejs from '../assets/skills/nodejs.svg';
import python from '../assets/skills/python.svg';
import react from '../assets/skills/react.svg';
import asw from '../assets/skills/AWS.svg';
import java from '../assets/skills/java.svg'
import ts from '../assets/skills/ts.svg'
import express from '../assets/skills/expressjs.svg'
import fastapi from '../assets/skills/fastapi.svg'
import tailwind from '../assets/skills/tailwind.svg'
import bootstrap from '../assets/skills/bootstrap.svg'
import nextjs from '../assets/skills/nextjs.svg'
import jquery from '../assets/skills/jquery.svg'
import postgress from '../assets/skills/postgress.svg'
import docker from '../assets/skills/docker.svg'
import bitbucket from '../assets/skills/bitbucket.svg'
import streamlit from '../assets/skills/streamlit.svg'
import linux from '../assets/skills/linux.svg'
import go from '../assets/skills/go.svg'
import kub from '../assets/skills/kub.svg'
import azure from '../assets/skills/azure.svg'

export const myskills = [
  { id: 1, skill: 'C', icon: c },
  { id: 2, skill: 'C++', icon: cplus },
  { id: 3, skill: 'CSS', icon: css },
  { id: 4, skill: 'Django', icon: django },
  { id: 5, skill: 'Java', icon: java },
  { id: 6, skill: 'Git', icon: git },
  { id: 7, skill: 'HTML', icon: html },
  { id: 8, skill: 'JavaScript', icon: javascript },
  { id: 9, skill: 'MongoDB', icon: mongodb },
  { id: 10, skill: 'MySQL', icon: mysql },
  { id: 11, skill: 'Node.js', icon: nodejs },
  { id: 12, skill: 'Python', icon: python },
  { id: 13, skill: 'React', icon: react },
  { id: 14, skill: 'AWS', icon: asw },
  { id: 15, skill: 'TypeScript', icon: ts },
  { id: 16, skill: 'Express.js', icon: express },
  { id: 17, skill: 'FastAPI', icon: fastapi },
  { id: 18, skill: 'Tailwind CSS', icon: tailwind },
  { id: 19, skill: 'Bootstrap', icon: bootstrap },
  { id: 20, skill: 'Next.js', icon: nextjs },
  { id: 21, skill: 'jQuery', icon: jquery },
  { id: 22, skill: 'PostgreSQL', icon: postgress },
  { id: 23, skill: 'Docker', icon: docker },
  { id: 24, skill: 'Bitbucket', icon: bitbucket },
  { id: 25, skill: 'Streamlit', icon: streamlit },
  { id: 26, skill: 'Linux', icon: linux },
  { id: 27, skill: 'Kubernetes', icon: kub },
  { id: 28, skill: 'Go', icon: go },
  { id: 29, skill: 'Azure', icon: azure },
];

// export default myskills;
